module.exports = {"start_date":"Start From","end_date":"End To","upload_btn":"Choose Excel","download_btn":"Get Excel","title":"Get Excel related"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/accounting/excel.json
// module id = Sjgh
// module chunks = 58